import React, { SVGProps } from 'react'
const SvgChevronUpLoD = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    aria-hidden="true"
    {...props}
  >
    <path
      fill="#FFF"
      d="m12 11.06-5.47 5.47a.75.75 0 1 1-1.06-1.06l6-6a.75.75 0 0 1 1.06 0l6 6a.75.75 0 0 1-1.06 1.06L12 11.06Z"
    />
  </svg>
)
export default SvgChevronUpLoD
